import type { FC } from 'react';
import {
  PurchaseSummary,
  useBreakpoint
} from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { selectBuyNowCartData } from '@/Application/Selectors/buyNow/useBuyNowCart';
import { setIsSummaryOpen } from '@/modules/buy-now/infrastructure/slices';
import {
  cartToCartData,
  deliveryInfoToShippingData
} from '@/modules/cart/infrastructure/mappers/cartToCartData';
import { useGetBuyNowCouponCartData } from '@/modules/perseo-billing/containers/billing/Summary/hooks/use-get-buy-now-coupon-data';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useFormattedAlternativePayments } from '@/Pages/BuyNowPage/hooks/useFormattedAlternativePayments';
import { usePaymentButton } from '@/Pages/BuyNowPage/hooks/usePaymentButton';
import {
  CONTINUE_EVENT,
  TOTALS_PRICES_TO_SHOW
} from '@/Pages/BuyNowPage/Summary/constants';

export const BuyNowSummary: FC = () => {
  const dispatch = useAppDispatch();
  const { isMobile, isTablet } = useBreakpoint();
  const isSummaryOpen = useAppSelector((state) => state.buyNow.isSummaryOpen);
  const cart = useAppSelector(selectBuyNowCartData);
  const { isTermsChecked, submissionHandler } = usePaymentButton();
  const couponData = useGetBuyNowCouponCartData();

  const { formattedPrice } = useFormattedAlternativePayments();

  const cartData = cart ? cartToCartData(cart) : undefined;
  const shippingData = cart?.deliveryInfo
    ? deliveryInfoToShippingData(cart.deliveryInfo)
    : undefined;

  const handleContinue = () => {
    sendEvent(CONTINUE_EVENT);
    submissionHandler();
  };

  const toggleSummary = () => {
    dispatch(setIsSummaryOpen(!isSummaryOpen));
  };

  if (!cartData) {
    console.warn('[BuyNowSummary] No cart data');
    return null;
  }

  return (
    <PurchaseSummary
      className={classNames(
        isSummaryOpen
          ? 'co-z-10 lg:co-z-auto co-rounded-none co-border-neutral-300'
          : 'co-z-10 lg:co-z-auto co-border-neutral-300'
      )}
      cartData={cartData}
      shippingData={shippingData}
      isOpen={isSummaryOpen}
      onContinueButtonLabel="Pagar"
      onEditCart={() => {}}
      onOpen={toggleSummary}
      onContinue={isMobile || isTablet ? handleContinue : undefined}
      continueButtonDisabled={!isTermsChecked}
      variant="fast-checkout"
      showCostsOnMobile={TOTALS_PRICES_TO_SHOW}
      totalPriceCenco={formattedPrice?.totalPriceCenco}
      totalPrice={formattedPrice?.totalPrice}
      couponData={couponData}
    />
  );
};

BuyNowSummary.displayName = 'BuyNowSummary';

export default BuyNowSummary;
